export default __webpack_public_path__ + "static/media/crew-01-bit.2fc31270.svg";